<script setup>
import FormInput from '../../../../components/Forms/FormInput.vue';

defineProps({
    question: {
        type: Object,
        required: true,
    },
});
const value = defineModel({ type: [Object], required: true });
</script>

<template>
    <div>
        <FormInput
            v-model="value.text"
            :required="question.is_required"
            :placeholder="question.is_required ? '' : $t('messages.survey_question_not_required_placeholder')"
            type="text"
            class="w-full"
            :name="`question_${question.id}`"
        />
    </div>
</template>
